module.exports = __webpack_public_path__ + "076f7cef757ee276c4036dc96308904b.pdf";